import {initializeApp} from 'firebase/app';
import {getFirestore} from 'firebase/firestore';
import {getAuth} from 'firebase/auth';
import {
	initializeAppCheck,
	ReCaptchaEnterpriseProvider,
} from 'firebase/app-check';

const firebaseConfig = {
	apiKey: 'AIzaSyCKEpaGwmZZPrcUuYxiF6tGaiCDa2uJk9U',
	authDomain: 'project-whirlwind.firebaseapp.com',
	projectId: 'project-whirlwind',
	storageBucket: 'project-whirlwind.appspot.com',
	messagingSenderId: '680687196531',
	appId: '1:680687196531:web:7c13f89b68f0f26a84cd06',
};

const appCheckConfig = {
	provider: new ReCaptchaEnterpriseProvider(
		process.env.REACT_APP_RECAPTCHA_SITE_KEY
			? process.env.REACT_APP_RECAPTCHA_SITE_KEY
			: '',
	),
	isTokenAutoRefreshEnabled: true,
};

declare global {
	// eslint-disable-next-line no-var
	var FIREBASE_APPCHECK_DEBUG_TOKEN: boolean;
}
if (process.env.REACT_APP_NODE_ENV === 'dev') {
	self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
initializeAppCheck(app, appCheckConfig);

export {auth, db};
